import { $$, Component, IComponentBindings, QueryEvents } from 'coveo-search-ui';

export type DisplayAction = () => void;

export class AtlasComponent extends Component {
	public domElement: Coveo.Dom;
	public hide: DisplayAction;
	public show: DisplayAction;
	public empty: DisplayAction;

	constructor(public element: HTMLElement, public id:string, public bindings: IComponentBindings) {
		super(element, id, bindings);
		this.domElement = $$(this.element);
		this.hide = this.domElement.hide.bind(this.domElement);
		this.show = this.domElement.show.bind(this.domElement);
		this.empty = this.domElement.empty.bind(this.domElement);

		this.bind.onRootElement(QueryEvents.queryError, this.hide);
	}
}



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/models/AtlasComponent.ts